import React, { createContext, useState } from "react";

// ================= APP CONTEXT =================

const AppContext = createContext();

export const AppProvider = ({ children }) => {

  // ================= BASIC STATE =================

  // For Development
  // const [baseUrl, setBaseUrl] = useState("http://127.0.0.1:8000/api");
  // const [baseUrlForFile, setBaseUrlForFile] = useState("http://127.0.0.1:8000/storage");

  // For Production
  const [baseUrl, setBaseUrl] = useState("https://workhub.btsportfolio2026.com/backend/public/api");
  const [baseUrlForFile, setBaseUrlForFile] = useState("https://workhub.btsportfolio2026.com/backend/public/storage");

  const [loggedInCustomer, setLoggedInCustomer] = useState(null);
  const [selectedCategoryForProducts, setSelectedCategoryForProducts] = useState("");
  const [authToken, setAuthToken] = useState("");
  const [kycStatus, setKycStatus] = useState(null);

  // ================= SIMPLE REGEX =================

  // Only letters and spaces
  const fullNameRegex = /^[A-Za-z ]+$/;

  // Simple email regex
  const emailRegex = /^\S+@\S+\.\S+$/;

  // Password minimum 6 characters
  const passwordRegex = /^.{6,}$/;

  // Phone number only digits, minimum 10 digits
  const phoneNoRegex = /^[0-9]{10,}$/;

  // City only letters and spaces
  const cityRegex = /^[A-Za-z ]+$/;

  // CNIC
  const cnicRegex = /^[0-9]{5}-[0-9]{7}-[0-9]{1}$/;

  // SNS
  const snsRegex = /^[0-9]{3}-[0-9]{2}-[0-9]{4}$/;

  // ================= VALIDATION FUNCTION =================

  const RegExpChecker = (type, input) => {
    switch (type) {

      case "fullName":
        if (!fullNameRegex.test(input)) {
          return {
            fullName: "Name should contain only letters.",
          };
        }
        return { fullName: "" };

      case "email":
        if (!emailRegex.test(input)) {
          return {
            email: "Please enter a valid email.",
          };
        }
        return { email: "" };

      case "password":
        if (!passwordRegex.test(input)) {
          return {
            password: "Password must be at least 6 characters.",
          };
        }
        return { password: "" };

      case "phone":
        if (!phoneNoRegex.test(input)) {
          return {
            phone: "Phone number must contain at least 10 digits.",
          };
        }
        return { phone: "" };

      case "city":
        if (!cityRegex.test(input)) {
          return {
            city: "City name should contain only letters.",
          };
        }
        return { city: "" };

      case "cnic":
        if (!cnicRegex.test(input)) {
          return {
            cnic: "Please enter valid CNIC (12345-1234567-1).",
          };
        }
        return { cnic: "" };

      case "sns":
        if (!snsRegex.test(input)) {
          return {
            sns: "Please enter valid SNS number.",
          };
        }
        return { sns: "" };

      default:
        return {};
    }
  };

  return (
    <AppContext.Provider
      value={{
        baseUrl,
        baseUrlForFile,

        authToken,
        setAuthToken,

        loggedInCustomer,
        setLoggedInCustomer,

        selectedCategoryForProducts,
        setSelectedCategoryForProducts,

        RegExpChecker,
        
        kycStatus,
        setKycStatus,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppContext;